
import isEmpty from 'lodash.isempty';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    headline: { type: String, default: '' },
    description: { type: String, default: '' },
    submitLabel: { type: String, default: '' },
    successTitle: { type: String, default: '' },
    successText: { type: String, default: '' },
    fields: { type: Array, default: () => [] },
    id: { type: String, default: '' },
    formCompleted: { type: Boolean, default: false },
    stackIndex: { type: Number, default: null },
    conversation: { type: String, default: '' },
  },

  data() {
    return {
      errors: {},
    };
  },

  computed: {
    ...mapState('formStore', ['formData', 'formOpen', 'formSubmitted']),
    ...mapGetters('chatbotStore', ['currentConversationId', 'currentStack', 'isPreview']),

    formVisible() {
      const isCurrentNode =
        this.conversation === this.currentConversationId && this.currentStack.length - 1 === this.stackIndex;

      return isCurrentNode && this.formOpen;
    },
  },

  watch: {
    fields: {
      deep: true,
      immediate: true,
      handler(fields) {
        if (!fields) return;
        this.fields.forEach((field) => {
          const { id, type } = field;
          let value = undefined;

          if (['input', 'textarea'].includes(type)) {
            value = '';
          }

          if (type === 'selectList') {
            value = field.options[0].value;
          }

          if (type === 'checkbox') {
            value = false;
          }

          this.updateFieldData({ key: id, value });
        });
      },
    },
  },

  methods: {
    ...mapActions('formStore', ['updateFieldData', 'setFormSubmitted', 'setFormOpen']),
    ...mapActions('chatbotStore', ['addToStorage']),

    hasError(fieldId) {
      return this.errors[fieldId];
    },

    onChange(e, field) {
      this.updateFieldData({ key: field, value: e });
    },

    checkForErrors() {
      this.errors = {};

      this.fields.forEach((field) => {
        if (field.required && !this.formData[field.id]) this.errors[field.id] = 'Field required.';
      });
    },

    handleSubmit() {
      this.checkForErrors();

      if (!isEmpty(this.errors)) return;

      this.setFormSubmitted({ state: true, stackIndex: this.stackIndex });
    },

    handleReturnToConversation() {
      this.setFormOpen({ state: false, stackIndex: this.stackIndex });

      if (!this.isPreview) {
        this.$tracking?.sendResponseEvent('form', {
          formId: this.id,
          conversationId: this.currentConversationId,
          stateType: 'CLOSE',
          statusType: !this.formSubmitted ? 'FALSE' : 'TRUE',
        });
      }
    },

    onCheckboxLabelClick(event) {
      if (event.target?.tagName === 'A') {
        event.stopPropagation();
      }
    },
  },
};
